/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// React
import { useEffect, useState } from 'react';

// UI lib components
import { Box } from '@mantine/core';

// UI local components
import { BackgroundImageAuth } from '@features/auth/components/BackgroundImageAuth';
import { FooterInfo } from '@features/auth/components/FooterInfo';
import { ForgotPassword } from '@features/auth/components/ForgotPassword/ForgotPassword';
import { SignIn } from '@features/auth/components/SignIn';

// Styles
import classes from './login.module.css';

// Constants
import { Text } from '@components/v2/ui';
import {
	BG_AREC_MOBILE,
	BG_AREC_TABLET,
	CONTACT_US_AREC_URL,
} from '@config/constants/common';
import { useBreakpoint } from '@hooks/useBreakpoint';
import { queryClient } from '@lib/react-query';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import packageJson from '../../../../../package.json';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */

const Auth = () => {
	/* ********************************** STATE ********************************* */
	const [authForm, setAuthForm] =
		useState<string>('signin');
	const { isTablet } = useBreakpoint();
	const navigate = useNavigate();
	/* ******************************** HELPERS ******************************* */
	const handlenavigate = (_target: string) => {
		setAuthForm(_target);
	};
	const { t, i18n } = useTranslation();
	const NavigateComponents = () => {
		if (authForm === 'signin')
			return <SignIn handlenavigate={handlenavigate} />;
		if (authForm === 'reset')
			return (
				<ForgotPassword handlenavigate={handlenavigate} />
			);
		return null;
	};

	useEffect(() => {
		queryClient.clear();
	}, []);

	/* ******************************** RENDERING ******************************* */
	return (
		<Box className={classes.container}>
			<Box className={classes.leftContainer}>
				<Box className={classes.backgroundImageMobile}>
					<BackgroundImageAuth
						url={
							isTablet ? BG_AREC_TABLET : BG_AREC_MOBILE
						}
						urlPartner="https://res.cloudinary.com/inuk/image/upload/v1757070408/LOGO-AREC-2019_gmmvnx.png"
					/>
				</Box>

				<Box
					className={classes.containerFormTabletMobile}
				>
					{NavigateComponents()}
					<FooterInfo
						contactUsUrl={CONTACT_US_AREC_URL}
					/>
				</Box>

				<Box className={classes.containerFormDesktop}>
					{NavigateComponents()}
					<FooterInfo
						contactUsUrl={CONTACT_US_AREC_URL}
					/>
				</Box>
				<Box
					style={{
						height: '100%',
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'flex-end',
					}}
					mt={'12px'}
					w={'70%'}
				>
					<Box
						style={{
							cursor: 'pointer',
						}}
						onClick={() => {
							navigate(`/cgu/${i18n.language}`);
						}}
					>
						<Text variant="caption" c={'#1D3965'}>
							{t('global.termsOfUse')}
						</Text>
					</Box>
					<Text variant="caption" c={'#1D3965'}>
						V {packageJson.version}
					</Text>
				</Box>
			</Box>

			<Box className={classes.rightContainer}>
				<BackgroundImageAuth
					url="https://res.cloudinary.com/inuk/image/upload/v1757085493/Illustration-login-AREC-V3--test-hauteur2.jpg_ngnath.jpg"
					urlPartner="https://res.cloudinary.com/inuk/image/upload/v1757070408/LOGO-AREC-2019_gmmvnx.png"
				/>
			</Box>
		</Box>
	);
};

export default Auth;
